<mat-card *ngIf="data">
    <mat-card-content>
        <div class="card-wrap">
            <div class="card-content">
                <app-portal-card-header *ngIf="data.icon" [title]="data.title" [iconUrl]="data.icon.umbracoFile" class="card-header" />
                <div class="card-description" [innerHTML]="data.descriprion"></div>
                <app-portal-button 
                    [target]="data.buttonTarget"
                    [link]="data.buttonLink"
                    classes="d-phone-tablet-none"
                    color="primary" 
                    [title]="data.buttonText"/>
            </div>

            <div class="card-video js-dmi" 
                [attr.youtube-id]="videoCode"
                [attr.youtube-url]="videoUrl"
                data-mfp="inline"
                data-mfp-src="#popup-yt">
                <app-video-preview [img]="data.videoPreviewImage" [time]="" />
            </div>
            <app-portal-button 
                [target]="data.buttonTarget"
                [link]="data.buttonLink"
                classes="w-100 d-not-phone-tablet-none mobile-btn"
                color="primary"
                [title]="data.buttonText"/>
        </div>
    </mat-card-content>
</mat-card>
<input type="hidden" id="shortedMinuteText" [value]="data.shortedMinuteText">
<div hidden>
    <div class="popup popup--yt" id="popup-yt">
        <button class="popup__close js-close-popup" aria-label="">
            <svg width="54" height="54" viewbox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M11.0135 41.8602C10.4314 42.4423 10.4314 43.3862 11.0135 43.9684C11.5957 44.5506 12.5396 44.5506 13.1218 43.9684L27.6578 29.4323L42.1933 43.9678C42.7755 44.55 43.7193 44.55 44.3015 43.9678C44.8837 43.3856 44.8837 42.4417 44.3015 41.8596L29.7661 27.3241L44.3015 12.7886C44.8837 12.2065 44.8837 11.2626 44.3015 10.6804C43.7193 10.0983 42.7755 10.0983 42.1933 10.6804L27.6578 25.2159L13.1218 10.6798C12.5396 10.0976 11.5957 10.0976 11.0135 10.6798C10.4314 11.262 10.4314 12.2059 11.0135 12.788L25.5496 27.3241L11.0135 41.8602Z"></path>
            </svg>
        </button>
        <div class="popup__iframe">
            <div class="youtube-video" id="ytplayer" data-src=""></div>
        </div>
    </div>
</div>